// removed by extract-text-webpack-plugin
module.exports = {"tiny":"380px","mobile":"768px","medium":"769px","large":"1024px","boldWeight":"700","regularWeight":"400","white":"#ffffff","whiteSmoke":"#f1f1f1","whiteFog":"#f9f9f9","whiteGrey":"#d8d8d8","black":"#353535","grey":"#707070","lightGrey":"#ccc","primary":"#e74d4f","secondary":"#353535","tertiary":"#e74d4f","error":"#e32438","success":"#79d38a","inactive":"#c6c6c6","billPrimary":"#077bc2"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/index.scss
// module id = 1464
// module chunks = 0